"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnhandledExceptionErrorHandlerDefinition = void 0;
const ErrorHandlerPlugin_1 = require("auto-widget-framework/src/Plugin/ErrorHandler/ErrorHandlerPlugin");
const ErrorHandlerPluginDefinition_1 = require("auto-widget-framework/src/Plugin/ErrorHandler/ErrorHandlerPluginDefinition");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
class UnhandledExceptionErrorHandler extends ErrorHandlerPlugin_1.default {
    /**
     * @inheritDoc
     */
    handle(error, widget) {
        return Promise.resolve().then(() => {
            return widget.setStep(StepTypes_1.StepTypes.ERROR);
        })
            .then(() => {
            // We still want to emit as error as well.
            widget.getEventContainer().emit(WidgetEvents_1.WidgetEvents.ERROR, error);
            // Since we are rendering a step and showing buttons for closing
            // the widget we must say that we handled the error so that
            // widget facade is received on the client side and
            // emits of close event are handled.
            return true;
        });
    }
}
exports.default = UnhandledExceptionErrorHandler;
exports.UnhandledExceptionErrorHandlerDefinition = new ErrorHandlerPluginDefinition_1.default({
    class: UnhandledExceptionErrorHandler,
    id: "unhandled_exception",
    priority: -9999 // Should apply as the last resort.
});
